import { useContext } from 'react';

import {
	MobileSignFormValuesContext,
	MobileSignFormCallbackContext,
} from '#src/app/pages/petitionDetails/shared/contexts';
import type { FormValues } from '#src/app/pages/petitionDetails/shared/types';

export type MobileSignFormContextValues = {
	mobileSignFormValues: FormValues | null;
	updateMobileSignFormValues: (values: FormValues) => void;
};

export const useMobileSignFormValues = (): MobileSignFormContextValues => {
	const mobileSignFormValues = useContext(MobileSignFormValuesContext);
	const updateMobileSignFormValues = useContext(MobileSignFormCallbackContext);

	if (mobileSignFormValues === undefined || !updateMobileSignFormValues) {
		throw new Error('MobileSignFormContext not found');
	}

	return { mobileSignFormValues, updateMobileSignFormValues };
};
